import { render } from "./NotificationListItem.vue?vue&type=template&id=f4ba19a8"
import script from "./NotificationListItem.vue?vue&type=script&lang=js"
export * from "./NotificationListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__